import { HttpHeaders } from '../interfaces';
import isRangeRequest from './isRangeRequest';

export default function isAllowedRangeRequest(
  app: string,
  headers: HttpHeaders
): boolean {
  switch (app) {
    case 'panopto':
    case 'keepeek.dam':
      return true;
    default:
      return !isRangeRequest(headers);
  }
}
